const phoneUtil =
  require("google-libphonenumber").PhoneNumberUtil.getInstance();

const PNF = require("google-libphonenumber").PhoneNumberFormat;
export const getDefaultCountry = (phoneNumber) => {
  try {
    var tel = phoneUtil.parse(phoneNumber);
  } catch (error) {
    return "us";
  }
  if (phoneUtil.getRegionCodeForNumber(tel)) {
    return phoneUtil.getRegionCodeForNumber(tel).toLowerCase();
  }
  return "";
};

export const formatInternationalPhoneNumber = (inputPhone) => {
  try {
    var tel = phoneUtil.parseAndKeepRawInput(inputPhone);
    if (!phoneUtil.isValidNumber(tel)) {
      return inputPhone;
    }
    return phoneUtil.format(tel, PNF.NATIONAL);
  } catch (exception) {
    return inputPhone;
  }
};

export const parseInternationalPhoneNumber = (inputPhoneNumber) => {
  try {
    const tel = phoneUtil.parse(inputPhoneNumber);
    const region = phoneUtil.getRegionCodeForNumber(tel)?.toLowerCase() ?? "us";
    if (!phoneUtil.isValidNumber(tel)) {
      return { phoneNumber: inputPhoneNumber, countryCode: region };
    } else {
      return {
        phoneNumber: phoneUtil.format(tel, PNF.NATIONAL),
        countryCode: region,
      };
    }
  } catch (e) {
    return { phoneNumber: inputPhoneNumber, countryCode: "us" };
  }
};
